// extracted by mini-css-extract-plugin
export default {"uploadFiles":"FileUpload_uploadFiles__yvXPW"};